// Gudang Rido/Rika: Pantau Produksi dibuka dari Menu header sebagai lapisan penuh (halaman di bawahnya tetap, posisi gulir dipulihkan).
// Tab Offline | Shopee | Tokopedia selalu tersedia; tab marketplace mengganti kanal (X-Channel) agar data tiap tab hanya dari kanalnya.
// Memakai ProductionMonitoring (mode simple) & endpoint yang sudah ada; tidak ada perhitungan baru.
import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { ProductionMonitoring } from "./production_monitoring";
import { SourceTab } from "./marketplace_brand";
import { useChannel } from "./channel";
import "./rido_pantau.css";

export function RidoPantauOverlay({ operator, onOpen, onClose, onSwitchChannel, initialSource = "shopee", extraStats = null }) {
  const ch = useChannel();
  const [src, setSrc] = useState(initialSource === "offline" ? "offline" : "market");
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => { document.body.style.overflow = prev; window.removeEventListener("keydown", onKey); };
  }, [onClose]);
  const pick = (t) => { if (t === "offline") { setSrc("offline"); return; } setSrc("market"); onSwitchChannel(t); };
  const tab = src === "offline" ? "offline" : ch;
  return <div className="rido-pantau" role="dialog" aria-modal="true" aria-label="Pantau Produksi" data-testid="rido-pantau-overlay">
    <div className="rido-pantau-head">
      <h3>Pantau Produksi</h3>
      <button type="button" className="op-lock-link rido-pantau-close" onClick={onClose} data-testid="rido-pantau-close" aria-label="Tutup Pantau Produksi">
        <X size={16} aria-hidden="true"/> Tutup</button>
    </div>
    <nav className="mpb-tabs rido-pantau-tabs" role="tablist" aria-label="Sumber pemantauan" data-testid="rido-pantau-tabs">
      <SourceTab channel="offline" active={tab === "offline"} onClick={() => pick("offline")} testid="rido-pantau-tab-offline"/>
      <SourceTab channel="shopee" active={tab === "shopee"} onClick={() => pick("shopee")} testid="rido-pantau-tab-shopee"/>
      <SourceTab channel="tokopedia" active={tab === "tokopedia"} onClick={() => pick("tokopedia")} testid="rido-pantau-tab-tokopedia"/>
    </nav>
    <ProductionMonitoring key={tab} operator={operator} onOpen={onOpen} source={src === "offline" ? "offline" : "shopee"} simple extraStats={extraStats}/>
  </div>;
}
